import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { API_URL } from '../constants';
import { Navbar } from '../components';

import '../styling/community.scss';

function Community() {
  const [filterData, setFilterData] = useState({
    city: '',
    travelers: 'Any',
    budget: 'Any',
    transport: 'Any',
    food: 'Any',
    lodging: 'Any',
  });
  const [trips, setTrips] = useState([]);
  const apiKey = useSelector((state) => state.data.mapKey);

  const navigate = useNavigate();

  const fetchFilteredTrips = async (filters) => {
    const queryString = Object.entries(filters)
      .filter(([_, value]) => value !== 'Any') // Exclude "Any" values
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');

    const url = `${API_URL}/api/trips/filter-trips?${queryString}`;
    console.log(url);

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Failed to fetch trips');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching trips:', error);
      return [];
    }
  };

  const applyFilters = async () => {
    console.log('Applying filters:', filterData);
    const filteredTrips = await fetchFilteredTrips(filterData);
    console.log(filteredTrips);
    setTrips(filteredTrips);
  };

  const handleFilterUpdate = (key, value) => {
    setFilterData((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const fetchRandomTrips = async () => {
      const randomTrips = await fetchFilteredTrips({});
      setTrips(randomTrips.slice(0, 10));
    };

    fetchRandomTrips();
  }, []);

  return (
    <div className="community-container">
      {/* Sidebar */}
      <div className="navbar"
        style={{
          position: 'fixed',
          height: '100%',
          flex: '0 0 auto',
          zIndex: 1000,
        }}
      >
        <Navbar />
      </div>

      <div className="community-content">
        <div className="header">
          <h1>Explore Your Next Destination...</h1>

          {/* Search Bar */}
          <div className="search-bar">
            <FontAwesomeIcon icon={faSearch} className="search-icon" />
            <GooglePlacesAutocomplete
              apiKey={apiKey}
              selectProps={{
                value: filterData.city ? { label: filterData.city, value: filterData.city } : null,
                onChange: (selected) => handleFilterUpdate('city', selected.label),
                placeholder: 'Search location...',
                styles: {
                  control: (provided) => ({
                    ...provided,
                    backgroundColor: 'transparent',
                    border: 'none',
                    boxShadow: 'none',
                    fontSize: '1em',
                    maxWidth: '450px',
                    color: '#333',
                  }),
                  input: (provided) => ({
                    ...provided,
                    color: '#333',
                    fontSize: '1em',
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: '#aaa',
                  }),
                  dropdownIndicator: (provided) => ({
                    ...provided,
                    display: 'none',
                  }),
                  indicatorSeparator: () => ({
                    display: 'none',
                  }),
                  menu: (provided) => ({
                    ...provided,
                    maxWidth: '500px',
                    minWidth: '300px',
                  }),
                },
              }}
              autocompletionRequest={{
                types: ['(cities)'],
              }}
            />
            <button className="search-button" onClick={applyFilters}>Search</button>
          </div>
        </div>

        {/* Filters */}
        <div className="filters-container">
          <div className="filters">
            <h2>Filters</h2>
            <div className="filter-rows">
              <div className="filter-row">
                <div className="filter-item">Travel Length
                  <input
                    type="number"
                    value={filterData.numDays}
                    onChange={(e) => handleFilterUpdate('numDays', e.target.value)}
                    placeholder="Number of days"
                  />
                </div>

                <div className="filter-item">Travelers
                  <select
                    value={filterData.travelers}
                    onChange={(e) => handleFilterUpdate('travelers', e.target.value)}
                  >
                    <option value="Any">Any</option>
                    <option value="Just Me">Just Me</option>
                    <option value="Couple">Couple</option>
                    <option value="Family">Family</option>
                    <option value="Friends">Friends</option>
                  </select>
                </div>

                <div className="filter-item">Budget
                  <select
                    value={filterData.budget}
                    onChange={(e) => handleFilterUpdate('budget', e.target.value)}
                  >
                    <option value="Any">Any</option>
                    <option value="Cheap">Cheap</option>
                    <option value="Moderate">Moderate</option>
                    <option value="Luxurious">Luxurious</option>
                  </select>
                </div>
              </div>

              <div className="filter-row">
                <div className="filter-item">Travel Type
                  <select
                    value={filterData.transport}
                    onChange={(e) => handleFilterUpdate('transport', e.target.value)}
                  >
                    <option value="Any">Any</option>
                    <option value="Car">Car</option>
                    <option value="Public Transport">Public Transport</option>
                    <option value="Bike">Bike</option>
                  </select>
                </div>

                <div className="filter-item">Food
                  <select
                    value={filterData.food}
                    onChange={(e) => handleFilterUpdate('food', e.target.value)}
                  >
                    <option value="Any">Any</option>
                    <option value="Local Food">Local Food</option>
                    <option value="Fast Food">Fast Food</option>
                    <option value="Fine Dining">Fine Dining</option>
                  </select>
                </div>

                <div className="filter-item">Lodging
                  <select
                    value={filterData.lodging}
                    onChange={(e) => handleFilterUpdate('lodging', e.target.value)}
                  >
                    <option value="Any">Any</option>
                    <option value="Hotel">Hotel</option>
                    <option value="Cabin">Cabin</option>
                  </select>
                </div>
              </div>
            </div>

            <button className="apply-filters-button" onClick={applyFilters}>Apply Filters</button>
          </div>
        </div>

        <div className="community-trips">
          <h2>Trips</h2>
          {trips.length === 0 ? <p>No trips found</p> : null}
          <div className="trip-cards">
            {trips.map((trip) => (
              <div key={trip.id} className="trip-card">
                <h3>{trip.userSelection.location.label}</h3>
                <div className="trip-buttons">
                  <button
                    className="details-button"
                    onClick={() => navigate(`/${trip._id}`)}
                  >
                    See More Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Community;
